import React, { useState } from 'react';
import { useMomentsContext } from './MomentsContext';
import isEmpty from 'lodash/isEmpty';
import Modal from '../../components/Modal';
import ProductSwap from '../productSwap/SelectProduct';
import SlidePanel from '../../components/SlidePanel';
import VariantSliderSelector from '../productSwap/VariantSliderSelector';
import { useTranslation } from 'react-i18next';
import { getCurrencyFormatter } from '../../utils';

export const ProductListModal = () => {
  const {
    productList,
    isProductListModalOpen,
    handleCloseProductListModal,
    handleClaimProductListReward,
  } = useMomentsContext();
  const [selectedProduct, setSelectedProduct] = useState<GlobalProduct | null>(
    {} as GlobalProduct,
  );
  const [selectedProductVariant, setSelectedProductVariant] =
    useState<GlobalVariant | null>({} as GlobalVariant);
  const [isOpenSlidePanel, setIsOpenSlidePanel] = useState(false);
  const handleOnCloseSlidePanel = () => {
    setIsOpenSlidePanel(false);
  };

  const handleChoose = (productId) => {
    const product = productList.find((product) => product.id === productId);
    setSelectedProductVariant(product?.variants[0]);
    setSelectedProduct(product);
    setIsOpenSlidePanel(true);
  };
  const { t } = useTranslation();
  const formater = getCurrencyFormatter(selectedProduct.priceCurrency);
  const price = formater(selectedProductVariant?.discountedPrice || 0);

  const comparePrice =
    selectedProductVariant?.discountedPrice !== selectedProductVariant?.price
      ? formater(selectedProductVariant?.price || 0)
      : null;
  return (
    <>
      <Modal
        onClose={handleCloseProductListModal}
        title={t('moments.productList.modal.title')}
        open={isProductListModalOpen}
        isCompleteScreen
      >
        <ProductSwap
          hasErrors={false}
          storeProducts={productList}
          handleChoose={handleChoose}
          isFetching={false}
          showDiscountedPrice={true}
        />
      </Modal>
      <SlidePanel
        id={selectedProduct?.id}
        handle={selectedProduct?.handle}
        open={isOpenSlidePanel}
        onClose={handleOnCloseSlidePanel}
        imgUrl={selectedProduct?.image}
        price={price || ''}
        comparePrice={comparePrice || ''}
        productName={selectedProduct.title}
        description={selectedProduct.descriptionHtml}
        hasOneVariant={selectedProduct?.variants?.length === 1}
        isLoading={!selectedProduct || isEmpty(selectedProduct)}
        variantName={selectedProductVariant?.title}
      >
        {selectedProduct ? (
          <VariantSliderSelector
            product={selectedProduct}
            selectedVariant={selectedProductVariant}
            onSelect={(selected) => {
              handleClaimProductListReward(selected.id);
              handleOnCloseSlidePanel();
            }}
            onConfirm={(selected) => {
              const selectedProductVariant = selectedProduct.variants.find(
                ({ id }) => id === selected.id,
              );
              setSelectedProductVariant(selectedProductVariant);
            }}
            showQuantityPicker={false}
          />
        ) : null}
      </SlidePanel>
    </>
  );
};
